export const API_ENDPOINTS = {
  // --- Actuals Data ---
  GET_ACTUALS: "getactuals",
  UPDATE_ACTUAL: "actual",
  CREATE_USER_ADDED_ACTUAL: "actual/useradd",

  // --- Actual Break-Ins ---
  // This single resource path is used for GET (all), POST, PUT, and DELETE operations.
  ACTUAL_BREAK_IN: "actualBreakIn",

  // --- Networks and Shows ---
  GET_NETWORKS_BY_DATE: "network",
  GET_NETWORKS_LIST: "getnetworkslist",
  GET_NETWORK_CHANNELS: "networkactualchannel",
  GET_SHOW_FILTERS: "getShowFilters",

  // --- User Management ---
  // This resource path is used for GET and POST user roles.
  USER_ROLE: "userRole",

  // --- Feedback ---
  FEEDBACK: "feedback",
};
// ${API_ENDPOINTS.USER_ROLE}
